/* Blue Quill Angler Fishing Reports - separate Guide Tips and Suggested Flies */
(function () {
  "use strict";
  var ENDPOINT = "https://script.google.com/macros/s/AKfycbzkzI6CWys6K1AF9s194rhV2qY1lSuRFa4OQdfPBYJMEkBXxB9cIjHofOfte3bb3Apk/exec";
  var CALLBACK = "bqaFishingReportsLoaded";

  function boxes() { return document.querySelectorAll('[data-bqa-fishing-report]'); }
  function str(v) { return v == null ? '' : String(v); }
  function trim(v) { return str(v).trim(); }
  function escapeHtml(v) { return str(v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;'); }
  function field(row, keys) {
    for (var i = 0; i < keys.length; i++) {
      if (row[keys[i]] != null) return row[keys[i]];
    }
    var lower = {};
    Object.keys(row || {}).forEach(function(k) { lower[k.toLowerCase().replace(/[^a-z0-9]/g, '')] = row[k]; });
    for (var j = 0; j < keys.length; j++) {
      var key = keys[j].toLowerCase().replace(/[^a-z0-9]/g, '');
      if (lower[key] != null) return lower[key];
    }
    return '';
  }
  function paragraphs(v) {
    return trim(v).split(/\r?\n+/).filter(function(s) { return trim(s); }).map(function(s) { return '<p>' + escapeHtml(s) + '</p>'; }).join('');
  }
  function productPath(url) {
    try {
      var u = new URL(trim(url), window.location.origin);
      if (!/^(bluequillangler\.com|www\.bluequillangler\.com|the-blue-quill-angler\.myshopify\.com)$/i.test(u.hostname)) return '';
      var match = u.pathname.match(/^\/products\/([a-zA-Z0-9_-]+)\/?$/);
      return match ? '/products/' + match[1] : '';
    } catch (e) { return ''; }
  }
  function parseFlies(value) {
    var flies = [], seen = {};
    if (!trim(value)) return flies;
    var root = document.createElement('div');
    root.innerHTML = str(value);
    Array.prototype.forEach.call(root.querySelectorAll('a[href]'), function(a) {
      var path = productPath(a.getAttribute('href'));
      if (!path || seen[path]) return;
      seen[path] = true;
      var sibling = a.nextSibling;
      var adjacent = sibling && sibling.nodeType === 3 ? sibling.nodeValue : '';
      var size = (adjacent.match(/#\s*\d+(?:\s*[-–]\s*\d+)?/i) || [''])[0];
      flies.push({ name: trim(a.textContent) || path.split('/').pop(), path: path, size: size });
    });
    return flies;
  }
  function legacyTips(raw) {
    var root = document.createElement('div');
    root.innerHTML = str(raw);
    Array.prototype.forEach.call(root.querySelectorAll('a[href]'), function(a) {
      if (!productPath(a.getAttribute('href'))) return;
      var next = a.nextSibling;
      if (next && next.nodeType === 3) next.nodeValue = next.nodeValue.replace(/^\s*#\s*\d+(?:\s*[-–]\s*\d+)?\s*[,;]?\s*/, '');
      a.parentNode.removeChild(a);
    });
    return trim(root.textContent.replace(/Suggested\s+flies\s*:/gi, '').replace(/^[,;\s]+|[,;\s]+$/g, ''));
  }
  function flyCards(flies) {
    if (!flies.length) return '';
    var html = '<div class="bqa-report-flies"><div class="bqa-report-flies-title">Suggested Flies</div><div class="bqa-report-fly-grid">';
    flies.forEach(function(f) {
      html += '<a class="bqa-report-fly-card" href="' + escapeHtml(f.path) + '" data-bqa-fly-product="' + escapeHtml(f.path) + '">' +
        '<div class="bqa-report-fly-image-wrap"><div class="bqa-report-fly-image-placeholder"></div></div>' +
        '<div class="bqa-report-fly-info"><div class="bqa-report-fly-name">' + escapeHtml(f.name) + '</div>' +
        (f.size ? '<div class="bqa-report-fly-size">' + escapeHtml(f.size) + '</div>' : '') +
        '<div class="bqa-report-fly-shop">Shop Fly</div></div></a>';
    });
    return html + '</div></div>';
  }
  function build(row) {
    var report = field(row, ['report']);
    var tips = field(row, ['tips']);
    var separate = field(row, ['suggested_flies', 'suggestedFlies', 'Suggested_Flies']);
    var updated = field(row, ['updated']);
    var flies = parseFlies(separate || tips);
    var guide = trim(separate) ? trim(tips) : legacyTips(tips);
    var html = '<div class="bqa-river-report">';
    if (trim(updated)) html += '<p class="bqa-report-updated"><em>Last updated: ' + escapeHtml(updated) + '</em></p>';
    html += '<div class="bqa-report-content">' + (trim(report) ? paragraphs(report) : '<p>Fishing report coming soon.</p>') + '</div>';
    if (guide) html += '<div class="bqa-report-tips"><h3>Guide Tips</h3>' + paragraphs(guide) + '</div>';
    html += flyCards(flies);
    return html + '</div>';
  }
  function images(box) {
    Array.prototype.forEach.call(box.querySelectorAll('[data-bqa-fly-product]'), function(card) {
      var path = card.getAttribute('data-bqa-fly-product');
      fetch(path + '.js', { credentials: 'same-origin' }).then(function(r) {
        if (!r.ok) throw Error('Product unavailable');
        return r.json();
      }).then(function(p) {
        var image = p.featured_image || (p.images && p.images[0]);
        if (!image) return;
        if (typeof image === 'object') image = image.src;
        if (!image) return;
        if (image.indexOf('//') === 0) image = 'https:' + image;
        var wrap = card.querySelector('.bqa-report-fly-image-wrap');
        if (!wrap) return;
        var img = document.createElement('img');
        img.className = 'bqa-report-fly-image';
        img.alt = trim(p.title) || 'Suggested fly';
        img.loading = 'lazy';
        img.src = image;
        wrap.textContent = '';
        wrap.appendChild(img);
      }).catch(function() { /* Keep clickable product card if image fails. */ });
    });
  }
  function message(text) {
    Array.prototype.forEach.call(boxes(), function(box) { box.innerHTML = '<p class="bqa-report-message">' + escapeHtml(text) + '</p>'; });
  }
  function display(response) {
    if (!response || response.success !== true || !Array.isArray(response.rows)) {
      message('The current fishing report could not be loaded.'); return;
    }
    Array.prototype.forEach.call(boxes(), function(box) {
      var slug = trim(box.getAttribute('data-river-slug')).toLowerCase();
      var row = response.rows.find(function(r) { return trim(field(r, ['river_slug', 'River_Slug'])).toLowerCase() === slug; });
      if (!row) { box.innerHTML = '<p class="bqa-report-message">Fishing report coming soon.</p>'; return; }
      box.innerHTML = build(row);
      images(box);
    });
  }
  function load() {
    if (!boxes().length) return;
    message('Loading current fishing report...');
    window[CALLBACK] = display;
    var script = document.createElement('script');
    script.async = true;
    script.src = ENDPOINT + '?callback=' + CALLBACK + '&cache=' + Date.now();
    script.onerror = function() { message('The current fishing report could not be loaded.'); };
    document.head.appendChild(script);
    setTimeout(function() {
      Array.prototype.forEach.call(boxes(), function(box) {
        if (box.textContent.indexOf('Loading current fishing report...') !== -1) {
          box.innerHTML = '<p class="bqa-report-message">The fishing report service did not respond.</p>';
        }
      });
    }, 10000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load);
  else load();
})();
